module.exports = __webpack_public_path__ + "img/analysis_03_02.15ee966b.png";